/**
 * This variation of the src/components/Loader component includes a message feature to keep the customer informed about
 * ongoing actions while the activity loader is visible.
 *
 * @see {@link /src/compnents/Loader/index.tsx}
 */

import clsx from "clsx";
import { Loader, LoaderBar } from "@screencloud/screencloud-ui-components";

import style from "./style.module.css";

interface Props {
  children?: React.ReactNode;
  overlay?: boolean;
  className?: string;
  "data-testid"?: string;
}

export function Loading(props: Props) {
  const className = clsx("__components_loading", style.container, props.overlay && style.overlay, props.className);

  /**
   * Return the component
   */
  return (
    <div data-testid={props["data-testid"]} className={className}>
      <LoaderBar />
      <Loader active inline />
      {props.children && (
        <div className={style.message}>
          <p>{props.children}</p>
        </div>
      )}
    </div>
  );
}
